import { injectable, inject } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { FeedRouter } from '../../../feed/types';
import { modules } from '../../modules';

@injectable()
export class FeedRouterService implements FeedRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToDetail(communityId: string, postId: string) {
    window.open(
      `/${modules.feed.basename}/${communityId}/post/${postId}`,
      '_blank',
    );
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${modules.feed.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${modules.feed.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  goToCommunity(id: string, slug: string) {
    this.history.push(`/${modules.community.basename}/${id}/${slug}`);
  }

  goToCommunities(query?: string) {
    if (!query || query === '?') {
      this.history.push(`/${modules.community.basename}`);
      return;
    }

    this.history.push({
      pathname: `/${modules.community.basename}`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }
}
